package com.milta.core.localization.translations.sq

import com.milta.core.localization.ImportsStrings

internal val Imports = ImportsStrings(
    titlePhoto = "Importo — Foto",
    titlePdf = "Importo — PDF",
    titleSpreadsheet = "Importo — Excel / CSV",
    fileSentSuffix = "dërguar tani",
    fileWaitingConnectionLabel = "duke pritur lidhjen",
    analysingTitle = "Duke lexuar dokumentin…",
    analysingSubtitle = "Nxjerrja e dërgesave mund të zgjasë disa sekonda.",
    analysingSubtitlePdf = "Claude Haiku nxjerr dërgesat — kjo mund të zgjasë disa sekonda për një PDF të skanuar.",
    stepFileSent = "Skedari u dërgua",
    stepExtracting = "Nxjerrja e fushave",
    stepReview = "Rishikim para shtimit",
    successTitle = "Dërgesa u zbulua",
    successSubtitle = "Kontrolloni informacionin para se ta shtoni në rrugë.",
    addToRouteButton = "Shto në rrugë",
    scanAnotherButton = "Skano një dokument tjetër",
    partialTitle = "Pothuajse i plotë",
    partialSubtitle = "Një fushë nuk mund të lexohej në dokument.",
    missingFieldPlaceholder = "Të plotësohet…",
    partialBannerText = "Disa informacione nuk mund të lexoheshin. Mund ta vlerësoni si është dhe t'i plotësoni më vonë, ose të ridërgoni një dokument më të qartë.",
    retryFileButton = "Ridërgo një skedar tjetër",
    validateAndContinueButton = "Vlerëso dhe vazhdo",
    attemptLabel = "Përpjekje",
    errorTitleUnreadable = "Dokument i palexueshëm",
    errorTitleMissingFields = "Informacioni nuk u gjet",
    errorTitleNetworkError = "Problem gjatë analizës",
    errorTitleGeneric = "Analiza dështoi",
    errorSubtitle = "Nuk mundëm të zbulojmë ndonjë dërgesë në këtë skedar.",
    errorBannerSuffixUnreadable = "imazhi shumë i errët ose teksti i prerë. Bëni një foto të kornizuar mirë dhe të ndriçuar mirë, ose dërgoni një skedar më të qartë.",
    errorBannerSuffixMissingFields = "nuk u gjet asnjë informacion i përdorshëm. Kontrolloni përmbajtjen e skedarit ose dërgoni një tjetër.",
    errorBannerSuffixNetworkError = "shërbimi i analizës hasi një problem rrjeti. Provoni përsëri pas pak.",
    errorBannerSuffixGeneric = "ndodhi një gabim i papritur gjatë analizës. Provoni përsëri ose dërgoni një skedar tjetër.",
    retryWithNewFileButton = "Provo përsëri me një skedar tjetër",
    manualEntryButton = "Fut manualisht",
    attemptsRemainingNote = "Ju kanë mbetur 1 përpjekje për këtë dokument.",
    maxAttemptsTitle = "Ende i palexueshëm",
    maxAttemptsSubtitle = "Ky dokument nuk mundi të lexohej pas 2 përpjekjeve.",
    maxAttemptsBanner = "Limiti i përpjekjeve u arrit për këtë dokument. Plotësoni dërgesën manualisht, ose rinisni importimin me një dokument të ri.",
    retryUnavailableButton = "Provo përsëri — jo në dispozicion",
    newDocumentButton = "Importo një dokument të ri",
    serviceUnavailableTitle = "Shërbimi përkohësisht jo në dispozicion",
    serviceUnavailableSubtitle = "Analiza automatike nuk përgjigjet për momentin.",
    serviceUnavailableBanner = "Provoni përsëri pas pak, ose plotësoni dërgesën manualisht ndërkohë.",
    offlineTitle = "Jeni jashtë linje",
    offlineSubtitle = "Skedari juaj është gati, por nuk është dërguar ende.",
    offlineBanner = "Rilidhuni me internetin, pastaj rinisni analizën. Asgjë nuk u dërgua në server — nuk u llogarit asnjë përpjekje.",
    retryOfflineButton = "Provo përsëri — pa lidhje",
    unsupportedFormatBanner = "Format skedari i pasuportuar. Zgjidhni një foto, PDF ose skedar Excel/CSV.",
    validationTitle = "Rishikoni dërgesat",
    fileRejectedTitle = "Skedari nuk u dërgua",
    fileRejectedSubtitle = "Zgjidhni një skedar tjetër për të vazhduar.",
    bannerFileRequired = "nuk u zgjodh asnjë skedar. Zgjidhni një skedar PDF për të vazhduar.",
    bannerInvalidPdfFormat = "format i pasuportuar. Këtu pranohen vetëm skedarë PDF.",
    bannerFileTooLarge = "skedar shumë i madh. Zgjidhni një skedar PDF më të lehtë.",
    chooseAnotherFileButton = "Zgjidh një skedar tjetër",
)
